"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _base = require("@mui/base");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _course = require("../../store/course");
var _materialEx = require("../../components/material-ex");
var _Style = require("../../style/Style");
var _lesson = require("../../store/lesson");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    currentCourse,
    setCurrentCourse,
    setCurrentCourseById
  } = (0, _course.useCourseStore)();
  const {
    lessons,
    fetchLessons,
    deleteLesson,
    errors
  } = (0, _lesson.useLessonStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      if (!props.id) {
        setLocation('/course');
        setToastText('コースが見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      setIsLoading(true);
      await fetchLessons(props.id);
      await setCurrentCourseById(props.id);
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    justifyContent: 'space-between',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      flexBasis: '40%',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        container: true,
        ...stylex.props(_Style.wrapper.mainTitle),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.h1),
          children: "\u30B3\u30FC\u30B9\u8A73\u7D30"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
          container: true,
          spacing: 2,
          direction: 'column',
          ...stylex.props(_Style.wrapper.stretchW),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            spacing: 1,
            direction: 'column',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1b),
              children: "\u30B3\u30FC\u30B9\u540D"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1),
              children: currentCourse.name
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            spacing: 1,
            direction: 'column',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1b),
              children: "\u30B3\u30FC\u30B9\u6982\u8981"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1),
              children: currentCourse.detail
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            spacing: 1,
            direction: 'column',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1b),
              children: "\u30B5\u30E0\u30CD\u30A4\u30EB"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.wrapper.detailImage),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: currentCourse.thumbnailPreviewUrl,
                alt: currentCourse.name,
                ...stylex.props(_Style.imageStyle.detail)
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            spacing: 1,
            direction: 'column',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1b),
              children: "\u6559\u6750\u6570"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1),
              children: currentCourse.lessonCount
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            spacing: 1,
            direction: 'column',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1b),
              children: "\u6559\u6750\u5408\u8A08\u52D5\u753B\u6642\u9593"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1),
              children: currentCourse.totalDurationText
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            spacing: 1,
            direction: 'column',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1b),
              children: "\u53D7\u8B1B\u4E2D\u306E\u30E6\u30FC\u30B6\u30FC\u6570"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.p1),
              children: "dummy"
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: 'column',
      flexBasis: '50%',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        container: true,
        direction: 'row',
        justifyContent: 'space-between',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.h1),
          children: "\u6559\u6750\u4E00\u89A7"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
          ...stylex.props(_Style.buttonStyle.primary),
          onClick: () => {
            setLocation('/course/' + currentCourse.id + '/lesson/add');
          },
          children: "\u6559\u6750\u3092\u8FFD\u52A0\u3059\u308B"
        })]
      }), lessons.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Table, {
          sx: {
            tableLayout: 'fixed'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableHead, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
                children: "\u6559\u6750\u540D"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
                children: "\u30B5\u30E0\u30CD\u30A4\u30EB"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
                children: "\u52D5\u753B\u6642\u9593"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {})]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableBody, {
            children: lessons.map(lesson => {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                  isSmall: true,
                  children: lesson.name
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                  isCenter: true,
                  isSmall: true,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: lesson.thumbnailPreviewUrl,
                    alt: lesson.name,
                    ...stylex.props(_Style.imageStyle.courseList)
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                  isSmall: true,
                  children: lesson.durationText
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                  isCenter: true,
                  isSmall: true,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
                    spacing: 2,
                    alignItems: 'flex-end',
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                      ...stylex.props(_Style.buttonStyle.secondary),
                      onClick: () => {
                        setLocation('/course/' + currentCourse.id + '/lesson/edit/' + lesson.id);
                      },
                      children: "\u7DE8\u96C6"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                      ...stylex.props(_Style.buttonStyle.secondary),
                      onClick: async () => {
                        if (!window.confirm('教材「' + lesson.name + '」を削除してもよろしいですか？')) return;
                        setIsLoading(true);
                        const deleteResult = await deleteLesson(lesson.id);
                        setIsLoading(false);
                        if (!deleteResult) {
                          setToastText('削除中にエラーが発生しました');
                          setToastOpen(true);
                          return;
                        }
                        setCurrentCourse({
                          lessonCount: currentCourse.lessonCount - 1,
                          totalDuration: currentCourse.totalDuration - lesson.duration
                        });
                        setToastText('教材「' + lesson.name + '」を削除しました');
                        setToastOpen(true);
                      },
                      children: "\u524A\u9664"
                    })]
                  })
                })]
              });
            })
          })]
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.p1b),
        children: errors.list || '該当する教材が存在しません'
      })]
    })]
  });
};
var _default = exports.default = App;